import { atom } from 'recoil';

export const logged = atom({
  key: 'logged',
  default: false,
});
